<template>
  <div
    class="flex flex-col lg:flex-row md:max-lg:[flex-flow:wrap] lg:space-x-4 bg-white rounded p-1"
    :class="{ 'border-4 border-yellow-400': highlighted }"
  >
    <div class="flex md:max-lg:items-center min-w-48 xl:min-w-80 max-w-48 xl:max-w-80 md:max-lg:w-1/2 mx-auto relative">
      <Link :href="route('frontend.auctions.show', {themeAuction: themeAuction.slug, auction: auction.slug})">
        <img
          class="min-w-full lg:relative lg:top-1/2 lg:-translate-y-1/2"
          :alt="auction.name"
          :src="auction.main_image_big"
        >
        <template v-if="auction.customer_has_highest_bid">
          <i
            class="fa fa-crown text-yellow-400 text-3xl absolute top-3 right-3 rotate-[22deg]"
            title="Jij hebt het hoogste bod!"
          />
        </template>
      </Link>
    </div>
    <div class="grow flex flex-col md:max-lg:w-1/2 pb-0 lg:pb-2 pt-2 px-2 lg:px-0">
      <div class="grow">
        <div class="flex flex-row justify-between items-center">
          <time
            class="text-3xl mb-1 tracking-wider invisible"
            data-format="short"
            :datetime="auction.auction_ends_at"
          >
            {{ auction.auction_ends_at }}
          </time>
          <div class="lg:hidden">
            <AuctionFavorite :auction="auction" />
          </div>
        </div>
        <div class="font-bold text-2xl mb-1">
          {{ auction.name }}
        </div>
        <div class="text-sm text-gray-500 mb-2">
          Openingsbod: {{ formatMoney(auction.starting_price) }}
          |
          <template v-if="auction.user">
            Aangeboden door: {{ auction.user }}
            |
          </template>
          EAN code: {{ auction.ean }}
        </div>
        <div>
          {{ auction.description_short }}
        </div>
      </div>
      <template v-if="auction.theme_auction">
        <div class="text-sm text-gray-350 mt-4">
          Thema veiling:
          <Link
            class="text-sky-500 underline hover:no-underline"
            :href="route('frontend.theme-auctions.show', auction.theme_auction.slug)"
          >
            {{ auction.theme_auction.name }}
          </Link>
        </div>
      </template>
    </div>
    <div class="lg:min-w-64 lg:max-w-64 md:max-lg:w-full py-1 px-2 lg:pr-2 lg:pl-0">
      <PlaceBid
        class="min-w-64"
        :item="auction"
        :enable-autobid="true"
        :hide-bids="true"
        @auction-updated="auctionUpdated"
      />
    </div>
  </div>
</template>

<script>
import {Link} from '@inertiajs/vue2';
import PlaceBid from '../Products/PlaceBid.vue';
import AuctionFavorite from './AuctionFavorite.vue';

export default {
  components: {
    AuctionFavorite,
    PlaceBid,
    Link,
  },

  props: {
    themeAuction: {
      required: true,
      type: Object,
    },

    auction: {
      required: true,
      type: Object,
    },

    highlighted: {
      required: false,
      type: Boolean,
      default: false,
    },
  },

  methods: {
    auctionUpdated(newAuction) {
      for (const key in newAuction) {
        if (key === 'latest_bid') {
          this.$set(this.auction, 'customer_has_highest_bid', newAuction[key].customer_id === this.$page.props.customer.id);
        } else {
          this.$set(this.auction, key, newAuction[key]);
        }
      }
    },
  },
};
</script>
